import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
const useJobPostingPayloadStore = create(
  persist(
    (set, get) => ({
      payload: {},
      setPayload: data => {
        set({
          payload: {
            ...get().payload,
            ...data
          }
        });
      },
      jobPostingStorageExists: false,
      setJobPostingStorageExists: value => {
        set({
          jobPostingStorageExists: value
        });
      },
      reset: () => {
        set({
          jobPostingStorageExists: false,
          payload: {}
        });
      }
    }),
    {
      name: "jobPostingPayload",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useJobPostingPayloadStore;
